import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { installWorkspacePopGuard } from './core/workspace/useWorkspaceDraftGuard';
import './index.css';
import reportWebVitals from './reportWebVitals';

// ── Sentry error monitoring ─────────────────────────────────────────────────
if (process.env.REACT_APP_SENTRY_DSN) {
  try {
    const Sentry = require('@sentry/react');
    Sentry.init({
      dsn:                    process.env.REACT_APP_SENTRY_DSN,
      environment:            process.env.NODE_ENV || 'development',
      tracesSampleRate:       0.1,
      replaysOnErrorSampleRate: 1.0,
      // Never send auth tokens or API keys in breadcrumbs/headers
      beforeSend(event) {
        if (event.request?.headers) {
          delete event.request.headers['Authorization'];
          delete event.request.headers['authorization'];
        }
        return event;
      },
    });
    window.__Sentry__ = Sentry;
  } catch {
    // @sentry/react not installed — skipping
  }
}

// ── PostHog analytics ───────────────────────────────────────────────────────
if (process.env.REACT_APP_POSTHOG_KEY) {
  try {
    const posthog = require('posthog-js').default;
    posthog.init(process.env.REACT_APP_POSTHOG_KEY, {
      api_host:        'https://app.posthog.com',
      autocapture:     false,
      capture_pageview: false,
    });
    window.posthog = posthog;
  } catch {
    // posthog-js not installed — skipping
  }
}

installWorkspacePopGuard();
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter useTransitions={false}>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
